import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    FileActionDirective,
    FileListActionDirective,
    FileListComponent,
    FileListItemComponent,
    FileListItemInfoDirective,
    LoadingSlateComponent,
} from '@exl-ng/mulo-common';

import { SharedModule } from '../../../shared/shared.module';
import { ArcviewModule } from '../../../parts/arcview/arcview.module';

import { AssetFilesAndLinksComponent } from './asset-files-and-links.component';
import { MatButtonModule } from '@angular/material/button';
import {
    HideOnPrintDirective,
    KeepOnPrintDirective,
    ShowOnlyOnPrintDirective,
} from '@exl-ng/mulo-core';

@NgModule({
    imports: [
        SharedModule,
        FileListComponent,
        FileListItemComponent,
        FileListItemInfoDirective,
        FileActionDirective,
        FileListActionDirective,
        RouterModule,
        LoadingSlateComponent,
        ArcviewModule,
        MatButtonModule,
        HideOnPrintDirective,
        ShowOnlyOnPrintDirective,
        KeepOnPrintDirective,
        AssetFilesAndLinksComponent,
    ],
    exports: [AssetFilesAndLinksComponent],
})
export class AssetFilesAndLinksModule {}
